__turbopack_context__.v({
  "DropdownTrigger": "attribution-display-module__7cd6Aa__DropdownTrigger",
  "Input": "attribution-display-module__7cd6Aa__Input",
  "Warning": "attribution-display-module__7cd6Aa__Warning",
  "disabled": "attribution-display-module__7cd6Aa__disabled",
});
